import { render, staticRenderFns } from "./IndexCom.vue?vue&type=template&id=7106f1fe&scoped=true"
import script from "./IndexCom.vue?vue&type=script&lang=js"
export * from "./IndexCom.vue?vue&type=script&lang=js"
import style0 from "./IndexCom.vue?vue&type=style&index=0&id=7106f1fe&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7106f1fe",
  null
  
)

export default component.exports